import { render, staticRenderFns } from "./CompartirFichaModal.vue?vue&type=template&id=3a81abdc&scoped=true"
import script from "./CompartirFichaModal.vue?vue&type=script&lang=js"
export * from "./CompartirFichaModal.vue?vue&type=script&lang=js"
import style0 from "./CompartirFichaModal.vue?vue&type=style&index=0&id=3a81abdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a81abdc",
  null
  
)

export default component.exports